import { toStringDate } from '@superbet-group/web.lib.utilities';
import {
    RegularSportTicketItem,
    SgaSportTicketItem,
} from '@superbet-group/web.types';

import ISelection from '@models/betSlip/ISelection';
import Odd from '@models/offer/Odd';
import { betBuilderService } from '@sportOfferFederation/bet-builder/services/betBuilder';

import { PropagatedSelectionAttributes } from './types';
import { prettyDecimal } from './utils';

export async function transformSportSelection(
    selection: ISelection,
    propagatedAttributes: PropagatedSelectionAttributes,
): Promise<RegularSportTicketItem | SgaSportTicketItem> {
    const odd = selection.odd!;
    const event = selection.event;
    const matchDate = toStringDate(event.date, apiDateFormat);

    const rest = odd.legs && (await betBuilderService.isSgaOddPriceEnabled())
        ? {
            itemComponents: odd.legs,
        } : {
            betGroupId: odd.marketId,
            eventName: event.fullName,
            eventCode: event.code,
            live: event.isOngoing(),
            marketId: odd.marketId,
            marketName: odd.marketName,
            marketUuid: odd.marketUuid,
            matchDate,
            matchDateUtc: matchDate, // they're the same on eventDto and in the docs
            matchId: event.id,
            matchName: event.fullName,
            oddCode: (odd as Odd).code,
            oddDescription: odd.description,
            oddFullName: odd.name,
            oddId: odd.id,
            oddName: odd.name,
            oddTypeId: odd.id,
            rules: event.rules,
            sbValue: odd.specialBetValue,
            selected: true, // hardcoded to true in score-alarm code too
            sportId: event.sportId,
            sportName: event.sportName,
            teamId1: `${event.team1Id}`,
            teamId2: `${event.team2Id}`,
            teamnameone: event.team1Name,
            teamnametwo: event.team2Name,
            tournamentId: event.tournamentId,
            tournamentName: event.tournamentName,
            uuid: odd.uuid, // TODO: replaced with oddUuid, should be cleaned up.
        };

    return {
        value: prettyDecimal(odd.value),
        type: selection.getItemType(),
        fix: propagatedAttributes.isSystem ? selection.isFixed : false,
        betRadarId: `${event.betRadarId}`,
        eventId: event.id,
        eventUuid: event.uuid,
        oddUuid: odd.uuid,
        sourceType: selection.sourceType,
        sourceScreen: selection.sourceScreen,
        ...rest,
    };
}

const apiDateFormat = 'yyyy-MM-dd HH:mm:ss';
